import React from "react";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import { cl1 } from "../../Constant";

function CustomerJobDetails() {
    return (
        <>
            <Header />
            <input
                id="getGiverUrlId"
                type="hidden"
                className="all-givers-id"
                value="<?php echo $giverId; ?>"
            />
            <input
                type="hidden"
                id="customer_user_id"
                className="customer_UserId"
            />
            <input type="hidden" id="careGiverId" className="currentGiverId" />
            <section className="jobs">
                <div className="container">
                    <div className="row">
                        <div className="col-md-9">
                            <p className="orange">Order Details</p>
                            <div className="d-flex">
                                <div className=" justify-content-between">
                                    <h5 className="blue customer-task-detail"></h5>
                                </div>
                                <div className="pl-5 mr-5 pt-2">
                                    <p>
                                        {" "}
                                        JOB ID (
                                        <span className="customer-job-id"></span>
                                        )
                                    </p>
                                </div>
                                <div className="clearfix col-xs-12">
                                    <a
                                        id="accept-giver-job"
                                        href="#;"
                                        className="btn btn-blue "
                                    >
                                        Accept Job
                                    </a>
                                    <a
                                        id="arrival-giver-job"
                                        href="#;"
                                        className="btn btn-blue"
                                        style={{ display: "none" }}
                                    >
                                        Arrival Confirmation
                                    </a>
                                    <a
                                        id="end-giver-job"
                                        href="#;"
                                        className="btn btn-blue"
                                        style={{ display: "none" }}
                                    >
                                        End Job
                                    </a>
                                </div>
                            </div>
                            <div className="row panel-r align-middle align-items-center">
                                <div className="col-md-3">
                                    <ul className="list-unstyled friend-list border-bottom border">
                                        <li className="active grey lighten-3  pl-1 pr-1">
                                            <a
                                                href="#"
                                                className="d-flex pt-2 justify-content-between"
                                            >
                                                <img
                                                    className="customer-giver-picture"
                                                    src={cl1}
                                                    width="50"
                                                    height="50"
                                                    className="rounded-circle"
                                                    alt="avatar"
                                                    className="avatar rounded-circle d-flex align-self-center mr-2 z-depth-1"
                                                />

                                                <div className="text-small">
                                                    <strong className="customer-giver-name"></strong>
                                                    <p className="last-message text-muted customer-bio">
                                                        <span className="orange"></span>
                                                    </p>
                                                </div>
                                                <div className="chat-footer pt-2">
                                                    <p className="text-smaller text-muted mb-0">
                                                        <i className="fa fa-star"></i>{" "}
                                                    </p>
                                                </div>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                                <div className="col-md-2 py-1">
                                    <span>
                                        <i className="fa fa-dollar"></i>{" "}
                                        <b>
                                            <span className="customer-job-amount">
                                                {" "}
                                                &nbsp
                                            </span>
                                            &nbsp
                                        </b>
                                        <span className="customer-job-paymentType"></span>
                                    </span>
                                </div>
                                <div className="col-md-2 py-1">
                                    <span>
                                        <i className="fa fa-calendar"></i>{" "}
                                        <span className="customer-job-startDate"></span>
                                    </span>
                                </div>
                                <div className="col-md-2 py-1">
                                    <span>
                                        <i className="fa fa-clock-o"></i>{" "}
                                        <span className="customer-job-startTime"></span>
                                    </span>
                                </div>
                                <div className="col-md-3 text-right py-1">
                                    <span className="p-14">
                                        <i className="fa fa-exclamation"></i>{" "}
                                        <span className="blue customer-job-status change-job-status"></span>
                                    </span>
                                </div>
                            </div>
                            <div className="row bot-p">
                                <div className="col-md-7">
                                    <p className="p-13">
                                        {" "}
                                        <i className="fa fa-map-marker orange"></i>{" "}
                                        <span className="customer-job-destination"></span>{" "}
                                        <span className="p-13">
                                            <a
                                                id="customer-view-on-map"
                                                target="_blank"
                                                href="http://maps.google.com/?q=10515 Fox Ave Fairdale, Kentucky(KY), 40118 TX | USA"
                                            >
                                                View on Map
                                            </a>
                                        </span>
                                    </p>
                                </div>
                                <div className="col-md-5 justify-content-right">
                                    <p className="justify-content-right p-13 text-right">
                                        {" "}
                                        Time Remaining{" "}
                                        <span>
                                            <span
                                                id="timeRemainingGiver"
                                                href="#"
                                                className="orange timeRemaining"
                                            ></span>
                                        </span>
                                    </p>
                                </div>
                            </div>
                            <hr />
                            <div className="timeline-parcours">
                                <div className="container-info">
                                    <div className="timeline-section-tl">
                                        <div className="parcours-box parc1">
                                            <div className="infobox date1">
                                                <p>Pending</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="timeline-section-tl">
                                        <div className="parcours-box parc1">
                                            <div className="infobox date1">
                                                <p>Accepted</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="timeline-section-tl">
                                        <div className="parcours-box parc3">
                                            <div className="infobox date1">
                                                <p>Arrived</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="timeline-section-tl">
                                        <div className="parcours-box parc2">
                                            <div className="infobox date1">
                                                <p>In Progress</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="timeline-section-tl">
                                        <div className="parcours-box parc2">
                                            <div className="infobox date1">
                                                <p>End By Giver</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="timeline-section-tl">
                                        <div className="parcours-box parc4">
                                            <div className="infobox date1">
                                                <p>Completed</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="container-time-line">
                                    <div className="time-line-parcours">
                                        <div className="timeline-indicator">
                                            <p className="indicator-val"></p>
                                        </div>
                                    </div>
                                </div>
                                <div className="container-bulle">
                                    <div className="timeline-section-tl">
                                        <div className="tl-round pending round1"></div>
                                    </div>
                                    <div className="timeline-section-tl">
                                        <div className="tl-round accepted round2"></div>
                                    </div>
                                    <div className="timeline-section-tl">
                                        <div className="tl-round arrived round4"></div>
                                    </div>
                                    <div className="timeline-section-tl">
                                        <div className="tl-round inProgress round3"></div>
                                    </div>
                                    <div className="timeline-section-tl">
                                        <div className="tl-round endGiver round3"></div>
                                    </div>
                                    <div className="timeline-section-tl">
                                        <div className="tl-round completed round5"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 col-lg-3 m-15 px-tb overfl mb-3">
                            <div className="job-item  box-shadow-only-hover hover-top border-all-1 border-color-gray py-3 border">
                                <div className="item-overlay ">
                                    <div className="job-info text-center align-self-center">
                                        <img
                                            src={cl1}
                                            className="text-center rounded-circle align-self-center customer-giver-picture"
                                            alt=""
                                            width="150"
                                            height="150"
                                        />
                                        <div className="text-center py-3">
                                            <h5>
                                                <a
                                                    href="#"
                                                    className="grey customer-giver-name"
                                                ></a>
                                            </h5>
                                            {/* <!--                                    <h6><a className="orange" href="#">Bubbles Studios</a></h6>--> */}
                                            <h6>
                                                Member since -{" "}
                                                <span className="customer-job-created"></span>
                                            </h6>
                                        </div>
                                        <div></div>
                                    </div>
                                    <ul className="tr-list job-meta list-unstyled job-social tr-list text-center">
                                        <li>
                                            <i
                                                className="fa fa-map-marker orange"
                                                aria-hidden="true"
                                            ></i>{" "}
                                            <span className="customer-job-country">
                                                {" "}
                                            </span>
                                        </li>
                                        {/* <!--                                <li><i className="fa fa-money orange" aria-hidden="true"></i> $ 2,000 - $ 2,500</li>--> */}
                                        <br />
                                        <li className="customer-bio"></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </>
    );
}

export default CustomerJobDetails;
